import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useUserStore } from '@/stores/user';

// Um único efeito observando o usuário do zustand cobre todos os caminhos
// que o alteram (login, cadastro, restauração de sessão no boot, logout)
// em vez de espalhar chamadas em cada handler de autenticação.
//
// Sem VITE_SENTRY_DSN configurada, Sentry.setUser é no-op.
function useSentryUser(): void {
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    if (user) {
      Sentry.setUser({ id: user.id, email: user.email, username: user.username });
    } else {
      Sentry.setUser(null);
    }
  }, [user]);
}

export { useSentryUser };
